// extracted by mini-css-extract-plugin
export var dividerContainer = "_6r-0";
export var line = "_6r-1";